export const StatesTab1 = [
  'E1', 'E2',
  'E3', 'E4', 'E5', 'E6', 'E7',  // CLIENTE
  'E10', 'E11', 'E12', 'E13', 'E14', // AVAL
  'E32', 'E33', 'E34', 'E35', 'E36', // AVAL RIESGO ALTO
  'E40', 'E41', 'E42', 'E43', 'E44', // AVAL RIESGO MUY ALTO
];
export const StatesTab2 = [
  'E8', 'E9',  // CLIENTE
  'E15', 'E16', // AVAL
  'E37', 'E38', // AVAL RIESGO ALTO
  'E45', 'E46', // AVAL RIESGO MUY ALTO
];

export const StatesTab3 = [
  'E17',  // IDENTIDAD CLIENTE
  'E18', // DOCS CLIENTE
  //'E19', // DOCS AVAL
  'E31', // IDENTIDAD AVAL
  'E39', // IDENTIDAD AVAL RIESGO ALTO
  'E47', // IDENTIDAD AVAL RIESGO MUY ALTO
  'E48', // DOCS AVAL RIESGO MUY ALTO
];

export const StatesTab4 = ['E20'];
export const StatesTab5 = ['E21', 'E22', 'E23', 'E24', 'E25', 'E26', 'E27', 'E28', 'E29', 'E50', 'E49', 'E51'];

export const SubStatesTab1 = [
  ['E1', 'E2', 'E3', 'E4', 'E10', 'E11', 'E32', 'E33', 'E40', 'E41'], // pantalla de crear cliente y generar nip
  ['E5', 'E12', 'E34', 'E42'], // aceptar terminos y condiciones
  ['E6', 'E13', 'E35', 'E43'], // aceptar consulta de buro
  ['E7', 'E14', 'E36', 'E44'], // resultado de buro
];

export const SubStatesTab2 = [
  ['E8', 'E15', 'E37', 'E45'],
  ['E9', 'E16', 'E38', 'E46'],
];

export const SubStatesTab3 = [
  ['E17', 'E31', 'E39', 'E47'],
  ['E18', 'E48']
];

export const SubStatesTab4 = [['E20']];

export const SubStatesTab5 = [['E21', 'E49'], ['E22'], ['E23', 'E24'], ['E25', 'E26', 'E50', 'E27'], ['E28'], ['E29'], ['E51']];

export const SetStates = [
  StatesTab1,
  StatesTab2,
  StatesTab3,
  StatesTab4,
  StatesTab5
]

export const SetSubStates = [
  SubStatesTab1,
  SubStatesTab2,
  SubStatesTab3,
  SubStatesTab4,
  SubStatesTab5
]

export const intervalBerauClient = StatesTab1.slice(3, 6);
export const isCreateClient = ['E2', 'E3'];

//pasos donde se levanta el sse para esperar respuesta de buro o riesgo inicial
export const isSSEState = ['E7', 'E14', 'E36', 'E44', 'E9', 'E16', 'E38', 'E46'];

export const stepsAfterMati = Array.from({ length: 23 }).map((current, index) => `E${index + 27}`);
export const stepsAfterUploadDocs = Array.from({ length: 22 }).map((current, index) => `E${index + 28}`);
export const stepsAfterSolicitud = Array.from({ length: 21 }).map((current, index) => `E${index + 29}`);

export const stepsAfterMatiB = ['E20', 'E26', 'E18'];
export const stepsAfterSolicitudB = ['E26', 'E18'];

// rango de aval normal
export const rangeNormalEndorsment = Array.from({ length: 7 }).map((current, index) => `E${index + 10}`);

// rango de aval riesgo alto
export const rangeHighRiskEndorsment = Array.from({ length: 7 }).map((current, index) => `E${index + 32}`);

// rango de aval riesgo muy alto
export const rangeVeryHighRiskEndorsment = Array.from({ length: 7 }).map((current, index) => `E${index + 40}`);

// pasos excluidos despues de riesgo final apra no tomar en cuenta vigencias
export const excludedStepsA = [...['E21', 'E22', 'E23', 'E24', 'E25', 'E26', 'E27', 'E28', 'E29','E49'], ...rangeHighRiskEndorsment, ...rangeVeryHighRiskEndorsment]
// export const excludedStepsB = [...['E21', 'E22', 'E23', 'E24', 'E25', 'E27', 'E28', 'E29','E50','E49'], ...rangeVeryHighRiskEndorsment, ...rangeVeryHighRiskEndorsment]

// pasos para deshabilitar el boton cambio de unidad
export const destroyBtnSteps = ['E32', 'E33', 'E34', 'E35', 'E36', 'E37', 'E38', 'E40', 'E41', 'E42', 'E43', 'E44', 'E45', 'E46', 'E47', 'E48', 'E49', 'E50'];

